export const MAX_SEARCH_EVENT_JSON_BYTES = 512

const textEncoder = new TextEncoder()

export function getJsonByteSize(value: unknown): number {
  return textEncoder.encode(JSON.stringify(value) ?? '').length
}

export function truncateForJsonByteBudget(value: string, maxLength: number, maxJsonBytes: number): string
export function truncateForJsonByteBudget(
  value: string | null | undefined,
  maxLength: number,
  maxJsonBytes: number,
): string | null
export function truncateForJsonByteBudget(
  value: string | null | undefined,
  maxLength: number,
  maxJsonBytes: number,
): string | null {
  if (!value) {
    return null
  }

  let result = ''

  for (const char of value) {
    const candidate = `${result}${char}`
    if (candidate.length > maxLength || getJsonByteSize(candidate) > maxJsonBytes) {
      break
    }

    result = candidate
  }

  return result
}
